<div class="form-group" [formGroup]="group">
    <label>{{field.label}}</label>
    <select class="form-control" [formControlName]="field.name" [ngClass]="{'custom-field-invalid': group.get(field.name).invalid}" >
        <option *ngFor="let option of field.options" [ngValue]="option.value">{{option.text}}</option>
    </select>

    <app-error-validation-messages [group]="group" [field]="field"></app-error-validation-messages>

</div>
